export default __webpack_public_path__ + "static/media/lock.e13ce951.svg";